import {combineReducers} from 'redux';
import showLoading from './showLoading';
import apiHandle from './apiHandle';
import user from './user';
import isCacheUseful from './isCacheUseful';

export default (page) => {
  return combineReducers({
    showLoading,
    apiHandle,
    user,
    page,
    query: (state = {}) => state,
    isCacheUseful
  });
};



// WEBPACK FOOTER //
// ./src/reducer/getReducer.js